import React, { useRef, useState } from "react";
import { cdnImg } from "../../../Utils/cdnImage";
import WebSkyLayout from "./WebSkyLayout";
import { useParams } from "react-router-dom";
import { useMatchDetailLogic } from "../../useLogic/useMatchDetailLogic";
import BookmakerSkyWeb from "./Bookmaker";
import FancySkyWeb from "./Fancy";
import SportbookWebSky from "./SportBook";
import { formatWithCommas } from "../../../Utils/Toast";
import BetFair from "./BetFair";
import LiveMatchTrackerCricket from "../../Score/Cricket/ScoerBoardDetail";
import { isEmpty } from "lodash";
import ReactPlayer from "react-player";
import LiveMatchTrackerSoccer from "../../Score/Soccer.js/ScoreBoardSoccer";
import LiveMatchTrackerTennis from "../../Score/Tennis/ScoreBoard";
import DisplayScore from "../../../component/DisplayScore";
import { BiSolidVolumeFull, BiSolidVolumeMute } from "react-icons/bi";
const DetailWebSky = () => {
  const parmas = useParams();
  const ref = useRef(null);
  const [showTv, setShowTv] = useState(false);
  const {
    // context
    user,
    profileData,
    showBetDialog,
    betSlipObject,
    setBetSlipObject,

    // state
    fancyModal,
    setFancyModal,
    loading,
    setLoading,
    mute,
    setTvClass,
    fancyTab,
    setFancyTab,
    marketNew,
    marketName,
    setMarketName,
    marketId,
    setMarketId,
    detail,
    bookmakerOdds,
    sportsBookPosition,
    bookmaker,
    fancy,
    sportsBook,
    fancyPosition,
    runner,
    setRunner,
    fancyHeader,
    favouriteList,
    setMute,

    // functions
    getBetPosition,
    getMatchOdds,
    addToFavioute,

    // memoized
    totalMatched,
    backOdds,
    layOdds,
    backOddsBookmaker,
    layOddsBookmaker,
    oldBack,
    oldLay,
    oldBackBookmaker,
    oldLayBookmaker,
    ms,
    positionMemo,
    positionMemoBookmaker,
    profileDataMemo,
    showFancy,
    showSportbook,

    tv,
    getMatchDetails,
  } = useMatchDetailLogic();

  return (
    <WebSkyLayout
      eventName={detail?.eventName}
      gameType={detail?.gameType}
      seriesName={detail?.seriesName}
    >
      {" "}
      <div id="centerColumn" className="col-center markets">
        <div id="overWrap" className="over-wrap live-match">
          <div id="liveMatchGameHead" className="game-head">
            <div id="matchTrackerWrap" className="match-tracker-wrap">
              {!["horse", "greyhound"].includes(parmas?.type) &&
                !isEmpty(detail?.scoreId) &&
                detail?.scoreId != "false" && <DisplayScore detail={detail} />}
              <ul id="liveMatchTrackerBtn" className="match-btn">
                <li>
                  <a
                    id="liveMultiMarketPin"
                    style={{ cursor: "pointer" }}
                    name="gameHeadPin"
                    className="btn-pin"
                  />
                </li>
                <li>
                  <a style={{ cursor: "pointer" }} className="btn-refresh" />
                </li>
              </ul>
            </div>
            <div id="scoresEvent" className="match-odds">
              Match Odds
              <img src={cdnImg("/assets/images/transparent.gif")} />
            </div>

            {detail?.status == "in_play" && (
              <ul className="game-info" style={{ display: "block" }}>
                <li id="gameInfoDate" className="green">
                  <img
                    className="icon-irun"
                    src={cdnImg("/assets/images/transparent.gif")}
                  />{" "}
                  In-Play
                </li>
              </ul>
            )}
            {/* <span id="lowLiquidityTag" className="game-low_liq" style={{}}>
              Low Liquidity
            </span> */}
            {detail?.status == "in_play" && (
              <a
                onClick={() => setShowTv(!showTv)}
                id="lmtOpenStreaming"
                className={`open-tv-wrap ${showTv ? "close_tv" : ""} `}
                style={{ display: "flex" }}
              >
                Live
              </a>
            )}
            <dl className="game-matched" style={{ display: "block" }}>
              <dt>Matched</dt>
              <dd id="liveGameMatched">
                USD{" "}
                {formatWithCommas(
                  marketNew?.length > 0 ? marketNew[0]?.odds?.totalMatched : 0,
                )}
              </dd>
            </dl>
            {/* <dl id="minMaxBox" className="fancy-info" style={{}}>
              <dt id="minMaxDt" style={{}}>
                Min/Max
              </dt>
              <dt id="maxDt" style={{ display: "none" }}>
                Max
              </dt>
              <dd id="minMaxInfo">100 / 8750</dd>
            </dl> */}
          </div>
          {showTv &&
            !isEmpty(user) &&
            detail?.status == "in_play" &&
            detail?.channel !== "false" && (
              <div
                id="tv-wrap"
                className="game-streaming-wrap"
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {loading && (
                  <img
                    src={cdnImg("assets/images/cover-live.webp")}
                    alt="Thumbnail"
                    className="w-full aspect-video relative"
                    style={{
                      padding: "0",
                      position: "absolute",
                      margin: "0",
                      left: "25%",
                      width: "inherit",
                      height: "inherit",
                    }}
                  />
                )}
                {!loading && (
                  <>
                    {!mute ? (
                      <BiSolidVolumeFull
                        onClick={() => setMute(true)}
                        size={24}
                        color="white"
                        style={{
                          position: "absolute",
                          right: "25%",
                          bottom: "10px",
                          zIndex: "99999",
                          color: "white",
                        }}
                      />
                    ) : (
                      <BiSolidVolumeMute
                        onClick={() => setMute(false)}
                        size={24}
                        color="white"
                        style={{
                          position: "absolute",
                          right: "25%",
                          bottom: "10px",
                          zIndex: "99999",
                          color: "white",
                        }}
                      />
                    )}
                  </>
                )}

                <ReactPlayer
                  muted={mute}
                  controls={false}
                  ref={ref}
                  playsinline={true}
                  loop={true}
                  playing={true}
                  id="videoFrame"
                  className="s-w-full s-aspect-video s-relative s-z-0"
                  onReady={() => setLoading(false)} // Video is ready → hide loader
                  onBuffer={() => setLoading(true)} // When buffering → show loader
                  onBufferEnd={() => setLoading(false)} // Buffer ends → hide loader
                  width={375}
                  height="100%"
                  url={`https://cceucceu.cc/${detail.channel}/index.m3u8`}
                  config={{
                    youtube: {
                      playerVars: {
                        showinfo: 1,
                        fs: 1,
                        controls: 1,
                      },
                    },

                    file: {
                      attributes: {
                        preload: "none",
                        crossOrigin: "true",
                      },
                      hlsOptions: {
                        startLevel: 3,
                      },
                    },
                  }}
                />
              </div>
            )}
          {(!isEmpty(profileData) && profileData?.minMatchingAmount > 0
            ? totalMatched > profileData?.minMatchingAmount
            : true) &&
            detail?.matchOdds == "on" &&
            marketNew?.map((res) => {
              return (
                res?.jsonData?.length > 0 && (
                  <BetFair
                    object={res}
                    runner={res?.jsonData}
                    backOdds={res?.odds?.back_odds}
                    layOdds={res?.odds?.lay_odds}
                    oldBack={res?.odds?.back_odds_old}
                    oldLay={res?.odds?.lay_odds_old}
                    ms={res?.odds?.ms}
                    name={res?.market}
                    marketId={res?.marketId}
                    totalMatched={res?.odds?.totalMatched}
                    detail={detail}
                    user={user}
                    profileData={profileDataMemo}
                    typeGame="betFaire"
                    marketName={res?.market}
                    position={positionMemo}
                  />
                )
              );
            })}

          {detail?.bookMaker == "on" &&
            detail?.gameType == "cricket" &&
            bookmaker?.length > 0 && (
              <BookmakerSkyWeb
                runner={bookmaker}
                marketId={parmas?.marketId}
                detail={detail}
                backOdds={backOddsBookmaker}
                layOdds={layOddsBookmaker}
                oldBack={oldBackBookmaker}
                oldLay={oldLayBookmaker}
                ms={detail?.bookMaker == "on" ? bookmakerOdds?.ms : 3}
                position={positionMemoBookmaker}
                profileData={profileDataMemo}
                addToFavioute={addToFavioute}
                typeGame="bookmaker"
                marketName={"Bookmaker"}
                user={user}
              />
            )}
          {fancyTab == "Fancy" && parmas?.type != "multi" && showFancy && (
            <FancySkyWeb
              fancy={fancy}
              detail={detail}
              fancyHeader={fancyHeader}
              position={fancyPosition}
              typeGame={"fancy"}
              setFancyTab={setFancyTab}
              profileData={
                detail?.matchSetting?.length > 0
                  ? {
                      ...detail,
                      arrayCheck: "details",
                      profile: profileData,
                    }
                  : {
                      ...profileData,
                      arrayCheck: "profile",
                      profile: profileData,
                    }
              }
              setFancyModal={setFancyModal}
            />
          )}
          {(parmas?.type == "multi" ? true : fancyTab == "Premium") &&
            showSportbook && (
              <SportbookWebSky
                data={sportsBook}
                user={user}
                favouriteList={favouriteList}
                detail={detail}
                setFancyTab={setFancyTab}
                position={sportsBookPosition}
                setBetSlipObject={setBetSlipObject}
                betSlipObject={betSlipObject}
                profileData={
                  detail?.matchSetting?.length > 0
                    ? {
                        ...detail,
                        arrayCheck: "details",
                      }
                    : {
                        ...profileData,
                        arrayCheck: "profile",
                      }
                }
                addToFavioute={addToFavioute}
              />
            )}
        </div>
      </div>
    </WebSkyLayout>
  );
};

export default DetailWebSky;
